import { DefaultService } from '@/services/DefaultService';

export default class RedeService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env);
    }

    save(lps) {
        return this._http.post(`${this._env}/pro/rede`, lps, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.handleError(err);
            }
        );
    }

    find(id) {
        return this._http.get(`${this._env}/pro/rede/${id}.json`, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.handleError(err);
            }
        );
    }

    delete(id) {
        return this._http.delete(`${this._env}/pro/rede/${id}`, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.handleError(err);
            }
        );
    }

    findAll(column, order, page, limit, situacao = 2, ...param) {
        return this._http
            .get(
                encodeURI(
                    `${
                        this._env
                    }/pro/rede.json?column=${column}&order=${order}&page=${page}&limit=${limit}&situacao=${situacao}&param=${param}`
                ),
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    findAllCombo(...param) {
        return this._http
            .get(
                encodeURI(`${this._env}/pro/rede/getcombo.json?param=${param}`),
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }
    updateSituacao(obj) {
        return this._http
            .post(`${this._env}/pro/rede/updatesituacao`, obj, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }
}
